export default __webpack_public_path__ + "static/media/1943.4028de74.png";